import { useHistory } from 'react-router-dom';
import { ReactComponent as TreatmentSVG } from 'icons/sd-treatment.svg';

import classnames from 'classnames';

import useWindowDimensions, {
  isMobileResolution,
} from 'helpers/useWindowDimensions';

import {
  TYPES,
  REFERRAL_STATUSES,
  EQUIPMENT_TYPES,
  EQUIPMENT_BADGE_TYPES,
} from 'config/treatment';

const TreatmentCardNew = ({ data, date, userType }) => {
  const history = useHistory();
  const { width } = useWindowDimensions();
  const isMobile = isMobileResolution(width);

  let doctor, org;

  if (data.doctor) {
    doctor = [data.doctor.lastName?.toUpperCase(), data.doctor.firstName]
      .filter(Boolean)
      .join(' ');
  }

  if (data.treatingOrg) {
    org = data.treatingOrg.name;
  }

  const articleClasses = classnames('grid-cards', {
    pointer: userType !== 'non-sleep',
  });

  const equipmentStatusCalsses = classnames('th-badge mr5', {
    'th-badge-green': data.equipmentStatus === 'equipped',
    'th-badge-grey': data.equipmentStatus === 'not equipped',
    'th-badge-pink': data.equipmentStatus === 'patient refused',
  });

  const referralStatusClasses = classnames('th-badge mr5', {
    'th-badge-green': data.referralStatus === 'referred',
    'th-badge-grey': data.referralStatus === 'to-be-referred',
  });

  const DesktopView = (
    <article
      className={articleClasses}
      onClick={() =>
        userType === 'non-sleep' ? null : history.push(`/treatments/${data.id}`)
      }
    >
      <div className="apps-card-left-new" style={{ gridColumn: 'span 6' }}>
        <div className="mr6">
          <TreatmentSVG />
        </div>
        <div className="apps-card-meta">
          <div className="apps-card-app-title-new">
            {TYPES.find((t) => t.id === data.type)?.label} treatment
          </div>
          <div className="flex flex-row" style={{ gap: '6px' }}>
            <div>
              {doctor && <p className="apps-card-app-desc-new">Doctor:</p>}
              {org && <p className="apps-card-app-desc-new">Organisation:</p>}
            </div>
            <div className="flex flex-column">
              {doctor && <p className="apps-card-app-desc-new">{doctor}</p>}
              {org && <p className="apps-card-app-desc-new">{org}</p>}
            </div>
          </div>
        </div>
      </div>
      {data.referralStatus && (
        <div className="apps-card-right-new" style={{ gridColumn: 'span 2' }}>
          <div className="mr5 flex">
            <span className={referralStatusClasses}>
              {
                REFERRAL_STATUSES.find(
                  (status) => status.id === data.referralStatus,
                ).label
              }
            </span>
          </div>
        </div>
      )}
      <div className="apps-card-right-new" style={{ gridColumn: 'span 2' }}>
        {data.equipmentStatus && EQUIPMENT_BADGE_TYPES.includes(data.type) && (
          <div className="mr5 flex">
            <span className={equipmentStatusCalsses}>
              {
                EQUIPMENT_TYPES.find(
                  (status) => status.value === data.equipmentStatus,
                ).label
              }
            </span>
          </div>
        )}
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 2 / -1', justifySelf: 'end' }}
      >
        <div>
          <p className="apps-card-app-desc-new">Creation date:</p>
          <p className="apps-card-app-desc-new">{date}</p>
        </div>
      </div>
    </article>
  );

  const MobileView = (
    <article
      className={articleClasses}
      onClick={() =>
        userType === 'non-sleep' ? null : history.push(`/treatments/${data.id}`)
      }
    >
      <div className="apps-card-left-new" style={{ gridColumn: 'span 10' }}>
        <div className="apps-card-meta ">
          <div className="apps-card-app-title-new">
            {TYPES.find((t) => t.id === data.type)?.label} treatment
          </div>

          <div className="flex flex-row" style={{ gap: '6px' }}>
            <div>
              {doctor && <p className="apps-card-app-desc-new">Doctor:</p>}
              {org && <p className="apps-card-app-desc-new">Organisation:</p>}
            </div>
            <div className="flex flex-column">
              {doctor && <p className="apps-card-app-desc-new">{doctor}</p>}
              {org && <p className="apps-card-app-desc-new">{org}</p>}
            </div>
          </div>
        </div>
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 2', justifySelf: 'end' }}
      >
        <div>
          <p className="apps-card-app-desc-new">Creation date:</p>
          <p className="apps-card-app-desc-new">{date}</p>
        </div>
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 6', gap: '8px' }}
      >
        {data.referralStatus && (
          <div className="mr5 flex">
            <span className={referralStatusClasses}>
              {
                REFERRAL_STATUSES.find(
                  (status) => status.id === data.referralStatus,
                ).label
              }
            </span>
          </div>
        )}
        {data.equipmentStatus && EQUIPMENT_BADGE_TYPES.includes(data.type) && (
          <div className="mr5 flex">
            <span className={equipmentStatusCalsses}>
              {
                EQUIPMENT_TYPES.find(
                  (status) => status.value === data.equipmentStatus,
                ).label
              }
            </span>
          </div>
        )}
      </div>
    </article>
  );

  return isMobile ? MobileView : DesktopView;
};

export default TreatmentCardNew;
